import loadable from '@loadable/component'

export const Header = loadable(() => import('./Header'))
export type { HeaderProps } from './Header'
